import React, { useEffect, useState } from 'react';
import { t, translate } from '../translation/Translation';
import { GET_SALES_NOTE_MEETING } from "routes/ApiEndpoints";
import Title from 'components/common/atoms/Title';
import { CENTRAL_DATA_MANAGEMENT_MICROSERVICE } from 'Constants';
import { ApiCall } from 'components/common/services/ApiServices';
import { Link, useParams } from 'react-router-dom';
import CustomNotify from 'components/common/atoms/CustomNotify';

interface MeetingProps {
    meetingType: string;
    meetingdate: string;
    meetingwith: string;
    meetingby: string;
    status: string;
    office: string;
    summary: string;
    title: string;
    detailedSummary: string;
}

const SalesNoteMeeting: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const [meeting, setMeeting] = useState<MeetingProps>({
        meetingType: "",
        meetingdate: "",
        meetingwith: "",
        meetingby: "",
        status: "",
        office: "",
        summary: "",
        title: "",
        detailedSummary: ""
    });

    const fetchMeetingDetails = async () => {
        const url = id ? `${GET_SALES_NOTE_MEETING}/${id}` : `${GET_SALES_NOTE_MEETING}`;
        // const response = await ApiCall.getService(
        //     url,
        //     "GET",
        //     CENTRAL_DATA_MANAGEMENT_MICROSERVICE,
        //     true);
        const response = await ApiCall.service(
            url,
            'POST',
            {},
            true,
            CENTRAL_DATA_MANAGEMENT_MICROSERVICE
        );

        if (response?.status === 200) {
            setMeeting(response?.data);
        } else {
            CustomNotify({
                type: "error",
                message: t("Some error occured")
            });
        }
    };

    useEffect(() => {
        fetchMeetingDetails();
    }, []);

    return (
        <div>
            <Title title={t("Meeting")} />
            <div className="form-height-vacancy-overview">
                <div className="row">
                    <div className="col-lg-3 col-5">
                        <div className="vacancyCornerLeftSection h-100">
                            <div className="tab-subtitle">{t("")}</div>
                            <div style={{ marginBottom: "1vw" }}>
                                <span>{t("Meeting title") + ":"}</span>
                                <span className="personal-info ms-2">
                                    {meeting.title ?? "-"}
                                </span>
                            </div>
                            <div style={{ marginBottom: "1vw" }}>
                                <span>{t("Meeting type") + ":"}</span>
                                <span className="personal-info ms-2">
                                    {meeting.meetingType ?? "-"}
                                </span>
                            </div>
                            <div style={{ marginBottom: "1vw" }}>
                                <span>{t("Date") + ":"}</span>
                                <span className="personal-info ms-2">
                                    {meeting.meetingdate ?? "-"}
                                </span>
                            </div>
                            <div style={{ marginBottom: "1vw" }}>
                                <span>{t("With") + ":"}</span>
                                <span className="personal-info ms-2">
                                    {meeting.meetingwith ?? "-"}
                                </span>
                            </div>
                            <div style={{ marginBottom: "1vw" }}>
                                <span>{t("By") + ":"}</span>
                                <span className="personal-info ms-2">
                                    {meeting.meetingby ?? "-"}
                                </span>
                            </div>
                            <div style={{ marginBottom: "1vw" }}>
                                <span>{t("Status") + ":"}</span>
                                <span className="personal-info ms-2">
                                    {meeting.status ?? "-"}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-9 col-xl-8 col-7">
                        {/* <div className="vacancySubTitle">{t("Basic summary")}</div> */}
                        {meeting.summary !== '' ?
                            <div className="color-dark-purple salesNoteMeeting">
                                <div dangerouslySetInnerHTML={{ __html: meeting.summary }} />
                            </div> :
                            <div className='text-center' style={{ paddingTop: "5vw" }}>Preparing meeting details ....</div>
                        }
                        {meeting.detailedSummary !== '' &&
                            <>
                                <div className="salesNoteSubtitle marginBottomPoint5">{t("Detailed summary")}</div>
                                <div className="color-dark-purple salesNoteMeeting">
                                    <div dangerouslySetInnerHTML={{ __html: meeting.detailedSummary }} />
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>
            <div className="col-md-6 align-self-center py-4">
                <Link
                    to="/manage/sales-note-meetings"
                    className=" back-btn text-decoration-underline"
                >
                    {t("Back")}
                </Link>
            </div>
        </div>
    )
}

export default translate(SalesNoteMeeting);